import React, {
  useEffect,
} from 'react';
import { FieldComponentProps } from 'components/anvilFormFillable/fields/types';
import InputText from 'components/common/InputText';
import { useFormContext } from 'react-hook-form';
import { isEmptyString } from 'utils/helper';

export default function SignatureInput({
  field,
  value,
  onChange,
  ...props
}: FieldComponentProps) {
  const { watch } = useFormContext();
  const signature = watch(field?.type ?? '');
  const onSignatureChange = (data: string) => {
    onChange?.({ ...value, value: data });
  };

  useEffect(() => {
    if (!isEmptyString(signature)) {
      onSignatureChange(signature);
    }
  }, [signature, field?.id, field?.formId]);

  const isImageSignature = typeof signature === 'string' && signature?.startsWith('data:image');

  return (isImageSignature ? (
    <div className="w-full border rounded bg-[var(--color-light)]">
      <img
        src={signature}
        alt="signature"
        className="max-h-10 object-contain"
      />
    </div>
  )
    : (
      <InputText
        {...props}
        id={field?.id ?? ''}
        key={field?.id ?? ''}
        placeholder="Please enter a value"
        value={signature ?? ''}
        disabled={!isEmptyString(signature)}
        onChange={(e) => {
          onSignatureChange(e.target.value);
        }}
        InputProps={{
          classes: {
            input: 'signature-color dancing-script-regular',
          },
        }}
        type="text"
        className="w-full"
      />
    )
  );
}
